/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  OrganizationFormResponseDTO,
  ParentOrganizationFormDetailDTO,
  ParentOrganizationFormListItemDTOQueryResultDTO,
  ParentOrganizationFormsGetAvailableFormsParams,
  SaveOrganizationFormResponseDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





export const parentOrganizationFormsGetAvailableForms = (
    organizationId: number,
    params?: ParentOrganizationFormsGetAvailableFormsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ParentOrganizationFormListItemDTOQueryResultDTO>(
      {url: `/api/organizations/${organizationId}/parent/ParentOrganizationForms`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getParentOrganizationFormsGetAvailableFormsQueryKey = (organizationId: number,
    params?: ParentOrganizationFormsGetAvailableFormsParams,) => {
    return [`/api/organizations/${organizationId}/parent/ParentOrganizationForms`, ...(params ? [params]: [])] as const;
    }

    
export const getParentOrganizationFormsGetAvailableFormsQueryOptions = <TData = Awaited<ReturnType<typeof parentOrganizationFormsGetAvailableForms>>, TError = ErrorType<unknown>>(organizationId: number,
    params?: ParentOrganizationFormsGetAvailableFormsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parentOrganizationFormsGetAvailableForms>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getParentOrganizationFormsGetAvailableFormsQueryKey(organizationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof parentOrganizationFormsGetAvailableForms>>> = ({ signal }) => parentOrganizationFormsGetAvailableForms(organizationId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof parentOrganizationFormsGetAvailableForms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ParentOrganizationFormsGetAvailableFormsQueryResult = NonNullable<Awaited<ReturnType<typeof parentOrganizationFormsGetAvailableForms>>>
export type ParentOrganizationFormsGetAvailableFormsQueryError = ErrorType<unknown>


export function useParentOrganizationFormsGetAvailableForms<TData = Awaited<ReturnType<typeof parentOrganizationFormsGetAvailableForms>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params: undefined |  ParentOrganizationFormsGetAvailableFormsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof parentOrganizationFormsGetAvailableForms>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof parentOrganizationFormsGetAvailableForms>>,
          TError,
          Awaited<ReturnType<typeof parentOrganizationFormsGetAvailableForms>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useParentOrganizationFormsGetAvailableForms<TData = Awaited<ReturnType<typeof parentOrganizationFormsGetAvailableForms>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: ParentOrganizationFormsGetAvailableFormsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parentOrganizationFormsGetAvailableForms>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof parentOrganizationFormsGetAvailableForms>>,
          TError,
          Awaited<ReturnType<typeof parentOrganizationFormsGetAvailableForms>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useParentOrganizationFormsGetAvailableForms<TData = Awaited<ReturnType<typeof parentOrganizationFormsGetAvailableForms>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: ParentOrganizationFormsGetAvailableFormsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parentOrganizationFormsGetAvailableForms>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useParentOrganizationFormsGetAvailableForms<TData = Awaited<ReturnType<typeof parentOrganizationFormsGetAvailableForms>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: ParentOrganizationFormsGetAvailableFormsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parentOrganizationFormsGetAvailableForms>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getParentOrganizationFormsGetAvailableFormsQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const parentOrganizationFormsGetForm = (
    organizationId: number,
    formId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ParentOrganizationFormDetailDTO>(
      {url: `/api/organizations/${organizationId}/parent/ParentOrganizationForms/${formId}`, method: 'GET', signal
    },
      );
    }
  

export const getParentOrganizationFormsGetFormQueryKey = (organizationId: number,
    formId: number,) => {
    return [`/api/organizations/${organizationId}/parent/ParentOrganizationForms/${formId}`] as const;
    }

    
export const getParentOrganizationFormsGetFormQueryOptions = <TData = Awaited<ReturnType<typeof parentOrganizationFormsGetForm>>, TError = ErrorType<unknown>>(organizationId: number,
    formId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parentOrganizationFormsGetForm>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getParentOrganizationFormsGetFormQueryKey(organizationId,formId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof parentOrganizationFormsGetForm>>> = ({ signal }) => parentOrganizationFormsGetForm(organizationId,formId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && formId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof parentOrganizationFormsGetForm>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ParentOrganizationFormsGetFormQueryResult = NonNullable<Awaited<ReturnType<typeof parentOrganizationFormsGetForm>>>
export type ParentOrganizationFormsGetFormQueryError = ErrorType<unknown>


export function useParentOrganizationFormsGetForm<TData = Awaited<ReturnType<typeof parentOrganizationFormsGetForm>>, TError = ErrorType<unknown>>(
 organizationId: number,
    formId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof parentOrganizationFormsGetForm>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof parentOrganizationFormsGetForm>>,
          TError,
          Awaited<ReturnType<typeof parentOrganizationFormsGetForm>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useParentOrganizationFormsGetForm<TData = Awaited<ReturnType<typeof parentOrganizationFormsGetForm>>, TError = ErrorType<unknown>>(
 organizationId: number,
    formId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parentOrganizationFormsGetForm>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof parentOrganizationFormsGetForm>>,
          TError,
          Awaited<ReturnType<typeof parentOrganizationFormsGetForm>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useParentOrganizationFormsGetForm<TData = Awaited<ReturnType<typeof parentOrganizationFormsGetForm>>, TError = ErrorType<unknown>>(
 organizationId: number,
    formId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parentOrganizationFormsGetForm>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useParentOrganizationFormsGetForm<TData = Awaited<ReturnType<typeof parentOrganizationFormsGetForm>>, TError = ErrorType<unknown>>(
 organizationId: number,
    formId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parentOrganizationFormsGetForm>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getParentOrganizationFormsGetFormQueryOptions(organizationId,formId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const parentOrganizationFormsStartResponse = (
    organizationId: number,
    formId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationFormResponseDTO>(
      {url: `/api/organizations/${organizationId}/parent/ParentOrganizationForms/${formId}/responses`, method: 'POST', signal
    },
      );
    }
  


export const getParentOrganizationFormsStartResponseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parentOrganizationFormsStartResponse>>, TError,{organizationId: number;formId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof parentOrganizationFormsStartResponse>>, TError,{organizationId: number;formId: number}, TContext> => {
    
const mutationKey = ['parentOrganizationFormsStartResponse'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof parentOrganizationFormsStartResponse>>, {organizationId: number;formId: number}> = (props) => {
          const {organizationId,formId} = props ?? {};

          return  parentOrganizationFormsStartResponse(organizationId,formId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ParentOrganizationFormsStartResponseMutationResult = NonNullable<Awaited<ReturnType<typeof parentOrganizationFormsStartResponse>>>
    
    export type ParentOrganizationFormsStartResponseMutationError = ErrorType<unknown>

    export const useParentOrganizationFormsStartResponse = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parentOrganizationFormsStartResponse>>, TError,{organizationId: number;formId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof parentOrganizationFormsStartResponse>>,
        TError,
        {organizationId: number;formId: number},
        TContext
      > => {

      const mutationOptions = getParentOrganizationFormsStartResponseMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const parentOrganizationFormsSaveResponse = (
    organizationId: number,
    responseId: number,
    saveOrganizationFormResponseDTO: SaveOrganizationFormResponseDTO,
 ) => {
      
      
      return customInstance<OrganizationFormResponseDTO>(
      {url: `/api/organizations/${organizationId}/parent/ParentOrganizationForms/responses/${responseId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveOrganizationFormResponseDTO
    },
      );
    }
  


export const getParentOrganizationFormsSaveResponseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parentOrganizationFormsSaveResponse>>, TError,{organizationId: number;responseId: number;data: SaveOrganizationFormResponseDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof parentOrganizationFormsSaveResponse>>, TError,{organizationId: number;responseId: number;data: SaveOrganizationFormResponseDTO}, TContext> => {
    
const mutationKey = ['parentOrganizationFormsSaveResponse'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof parentOrganizationFormsSaveResponse>>, {organizationId: number;responseId: number;data: SaveOrganizationFormResponseDTO}> = (props) => {
          const {organizationId,responseId,data} = props ?? {};

          return  parentOrganizationFormsSaveResponse(organizationId,responseId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ParentOrganizationFormsSaveResponseMutationResult = NonNullable<Awaited<ReturnType<typeof parentOrganizationFormsSaveResponse>>>
    export type ParentOrganizationFormsSaveResponseMutationBody = SaveOrganizationFormResponseDTO
    export type ParentOrganizationFormsSaveResponseMutationError = ErrorType<unknown>

    export const useParentOrganizationFormsSaveResponse = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parentOrganizationFormsSaveResponse>>, TError,{organizationId: number;responseId: number;data: SaveOrganizationFormResponseDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof parentOrganizationFormsSaveResponse>>,
        TError,
        {organizationId: number;responseId: number;data: SaveOrganizationFormResponseDTO},
        TContext
      > => {

      const mutationOptions = getParentOrganizationFormsSaveResponseMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const parentOrganizationFormsSubmitResponse = (
    organizationId: number,
    responseId: number,
    saveOrganizationFormResponseDTO: SaveOrganizationFormResponseDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationFormResponseDTO>(
      {url: `/api/organizations/${organizationId}/parent/ParentOrganizationForms/responses/${responseId}/submit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: saveOrganizationFormResponseDTO, signal
    },
      );
    }
  


export const getParentOrganizationFormsSubmitResponseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parentOrganizationFormsSubmitResponse>>, TError,{organizationId: number;responseId: number;data: SaveOrganizationFormResponseDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof parentOrganizationFormsSubmitResponse>>, TError,{organizationId: number;responseId: number;data: SaveOrganizationFormResponseDTO}, TContext> => {
    
const mutationKey = ['parentOrganizationFormsSubmitResponse'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof parentOrganizationFormsSubmitResponse>>, {organizationId: number;responseId: number;data: SaveOrganizationFormResponseDTO}> = (props) => {
          const {organizationId,responseId,data} = props ?? {};

          return  parentOrganizationFormsSubmitResponse(organizationId,responseId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ParentOrganizationFormsSubmitResponseMutationResult = NonNullable<Awaited<ReturnType<typeof parentOrganizationFormsSubmitResponse>>>
    export type ParentOrganizationFormsSubmitResponseMutationBody = SaveOrganizationFormResponseDTO
    export type ParentOrganizationFormsSubmitResponseMutationError = ErrorType<unknown>

    export const useParentOrganizationFormsSubmitResponse = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parentOrganizationFormsSubmitResponse>>, TError,{organizationId: number;responseId: number;data: SaveOrganizationFormResponseDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof parentOrganizationFormsSubmitResponse>>,
        TError,
        {organizationId: number;responseId: number;data: SaveOrganizationFormResponseDTO},
        TContext
      > => {

      const mutationOptions = getParentOrganizationFormsSubmitResponseMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    